(function () {
  const SELECTOR = ':not(.shopify-design-mode) .fade-up-animation';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsIO = 'IntersectionObserver' in window;
  let observer = null;

  const reveal = el => {
    if (!el || el.classList.contains('animate')) return;
    requestAnimationFrame(() => el.classList.add('animate'));
  };

  const observeElement = el => {
    if (!el || el.dataset.fadeUpBound === 'true') return;
    el.dataset.fadeUpBound = 'true';

    if (prefersReducedMotion || !observer) {
      reveal(el);
      return;
    }

    observer.observe(el);

    // If the element is already in view when bound, animate immediately to avoid missed triggers.
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      reveal(el);
    }
  };

  const bindAll = () => {
    document.querySelectorAll(SELECTOR).forEach(observeElement);
  };

  const initObserver = () => {
    if (!supportsIO || prefersReducedMotion) return;

    observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.2
    });
  };

  const watchNewElements = () => {
    const mo = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches(SELECTOR)) observeElement(node);
          node.querySelectorAll?.(SELECTOR).forEach(observeElement);
        });
      });
    });

    mo.observe(document.body, { childList: true, subtree: true });
  };

  const ensureVisibleAfterLoad = () => {
    window.addEventListener('load', () => {
      requestAnimationFrame(() => {
        document.querySelectorAll(SELECTOR).forEach(reveal);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initObserver();
    bindAll();
    watchNewElements();
    ensureVisibleAfterLoad();
  });
})();
